import React, { useEffect } from 'react'
import styles from './Select.module.scss'

export const Select = ({ disabled = false, id, options, onChange, onboarding, value = {} }) => {
    useEffect(() => {
        if (!value.value) {
            document.getElementById(id).selectedIndex = 0
        }
    }, [value, id])

    return (
        <select
            className={`${styles.select} ${onboarding && styles.onboardingContentSelect}`}
            {...{ id, onChange: event => onChange(event.target.value) }}
            value={value.value}
            disabled={disabled}
        >
            {options.map(({ label, value }) => (
                <option key={value} value={value}>
                    {label}
                </option>
            ))}
        </select>
    )
}
